<template>
    <div>
        <base-dialog v-model="showDialog" keepOpened :title="`${$t('appointmentCancel.cancel')} ${appointmentType}`"
      :okBtnText="`${$t('appointmentCancel.wantToCancel')} (${appointmentType})`" :okBtnVariant="'danger'" :cancelBtnText="$t('back')" :cancelBtnVariant="'secondary'"
      :okFn="() => { cancelConsultation() }" :cancelFn="() => { $emit('toggleCancelAppointment') }">
        <template>
            <b-row v-if="appointmentDetails.patientData">
                <b-col cols="12" xs="12" md="6" lg="6" xl="6">
                    <b-row>
                        <h5>{{ $t('appointmentCancel.patientData') }}</h5>
                    </b-row>
                    <b-row class="align-items-center">
                        <b-col cols="5" xs="5">
                            <b-row><img class="details-photo" :src="appointmentDetails.patientData.photo" alt=""></b-row>
                        </b-col>
                        <b-col class="details-container" cols="7" xs="7">
                            <b-row><p class="details-name"><strong>{{ appointmentDetails.patientData.fullName }}</strong></p></b-row>
                            <b-row><p class="details-text">{{ appointmentDetails.patientData.fullAddress }}</p></b-row>
                            <b-row><p class="details-text">{{ appointmentDetails.patientData.email }}</p></b-row>
                            <b-row><p class="details-text">{{ appointmentDetails.patientData.phonenumber }}</p></b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" xs="12" md="6" lg="6" xl="6" class="appointment-container">
                    <b-row>
                        <h5>{{ $t('appointmentCancel.appointmentSummary') }}</h5>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-row><p class="details-text"><strong>{{ `${$t('date')}:` }}</strong> {{ formattedAppointmentDate }}</p></b-row>
                            <b-row v-if="appointmentDetails.duration"><p class="details-text"><strong>{{ `${$t('duration')}:` }}</strong> {{ appointmentDetails.duration }}</p></b-row>
                            <b-row><p class="details-text"><strong>{{ `${$t('price')}:` }}</strong> {{ appointmentDetails.price }} {{ currency }}</p></b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="reason-container">
                <b-row><h5>{{ $t('appointmentCancel.cancelationReason') }}</h5></b-row></b-row>
                <b-row><base-textarea :rows="1" :max-rows="5" class="message-text mt-2" v-model="cancelReason" :placeholder="$t('appointmentCancel.writeAReason')"></base-textarea></b-row>
        </template>
      </base-dialog>
    </div>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue'
import { getConsultationTitleById } from '@/constants/consultationTypes'
import AppointmentsRepository from '@/repositories/AppointmentsRepository'
import { appointmentDateFormat } from '@/helpers/date.helpers'
import { getCurrencyByDomain } from '@/constants/currencies'
export default {
    components: {
        BaseDialog
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        appointmentId: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            cancelReason: null,
            appointmentType: '',
            appointmentDetails: {},
            userInfo: {}
        }
    },
    methods: {
        cancelConsultation () {
            if (!this.cancelReason) {
                this.$store.dispatch('showDangerAlert', this.$t('appointmentCancel.noCancelReason'))
            } else {
                // AppointmentsRepository.cancelAppointment(this.appointmentId, this.appointmentDetails.patientId, this.cancelReason).then((response) => {
                this.$ouicareApi.get('Agendas/CancelPersonalAppointmentProfessional', {appointmentID: this.appointmentId, idPaciente: this.appointmentDetails.patientId, Motivo: this.cancelReason}).then((response) => {
                    if (response.data.status === 200) {
                        this.$store.dispatch('showSuccessAlert', this.$t('appointmentCancel.cancel-success'))
                        this.cancelReason = null
                        this.$emit('toggleCancelAppointment')
                    } else {
                        this.$store.dispatch('showDangerAlert', this.$t('appointmentCancel.cancel-error'))
                    }
                })
            }
        }
    },
    computed: {
        formattedAppointmentDate () {
            return appointmentDateFormat(this.appointmentDetails.fromDateTime)
        },
        currency () {
            return getCurrencyByDomain()
        }
    },
    watch: {
        'showDialog' (value) {
            if (value) {
                AppointmentsRepository.getAppointmentDetails(this.appointmentId).then((response) => {
                    this.appointmentDetails = response.data.data
                    this.appointmentType = getConsultationTitleById(response.data.data.type).toLowerCase()
                })
            }
        }
    }
}
</script>

<style lang="scss">
.details-photo {
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    margin: 1rem 1rem 0.75rem;
    vertical-align: middle;

    @include mobile {
        width: 5rem;
        height: 5rem;
    }
}
.details-container {
    height: 10rem;
    text-align: center;
}
.appointment-container {
    padding-left: 1.5rem;

    @include mobile {
        padding-top: 1.5rem;
        padding-left: 0;
    }
}
.details-text {
    margin: 0.4rem 0;
    font-size: 0.9rem;

    @include mobile {
        font-size: 0.8rem;
    }
}
.details-name {
    margin-top: 0.4rem;
    font-size: 1.2rem;
    margin-bottom: 0.1rem;
    @include mobile {
        font-size: 1rem;
    }
}
.reason-container {
    padding-top: 1.5rem;
}
.message-text {
    width: 100%;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/shared/CancelAppointmentModal.vue